// Helper de infraestructura que aísla la escritura directa a localStorage del flujo OTP (UC-5).
// R-3 (B-2, preservado as-is): NO llama a ningún hook/contexto de React — application/
// useOtpVerification.ts es quien decide no sincronizar @modules/iam tras persistir.

export interface OtpSession {
  token: string;
  refreshToken: string;
  user: Record<string, unknown>;
}

export const otpSession = {
  persist(session: OtpSession): void {
    localStorage.setItem('token', session.token);
    localStorage.setItem('refreshToken', session.refreshToken);
    localStorage.setItem('user', JSON.stringify(session.user));
  },
};
